module.exports = __webpack_public_path__ + "img/LUB00095.a70697cf.png";